import { ampli } from "@/ampli"
import { Text } from "@/elements"
import { VimeoLogo } from "@/svg/VimeoLogo"
import type { NovaSession } from "@/types"
import { decodeGraphqlNodeId } from "@/tracking"
import { Instagram, Link, Linkedin, Mail, Twitter } from "react-feather"

export type ContactType = "email" | "website" | "linkedin" | "instagram" | "twitter" | "vimeo"

interface Props {
  url: string
  type: ContactType
  label?: string
  tracking: {
    type: "client" | "creative"
    id?: string
  }
  serverSession: NovaSession | null
  upsellSubscription?: boolean
  openProModal: () => void
}

const getIcon = (type: ContactType) => {
  switch (type) {
    case "email":
      return <Mail size={22} />
    case "website":
      return <Link size={22} />
    case "linkedin":
      return <Linkedin size={22} />
    case "instagram":
      return <Instagram size={22} />
    case "twitter":
      return <Twitter size={22} />
    case "vimeo":
      return <VimeoLogo height={22} width={22} />
    default:
      return null
  }
}

export const ContactButton: React.FC<Props> = ({
  url,
  type,
  label,
  tracking,
  serverSession,
  upsellSubscription = true,
  openProModal,
}) => {
  const onClick = () => {
    if (upsellSubscription) {
      openProModal()
      return
    }
    ampli.profileLinkClick({
      client_id: tracking.type === "client" ? decodeGraphqlNodeId(tracking.id).numericalId || "" : "",
      creative_id: tracking.type === "creative" ? decodeGraphqlNodeId(tracking.id).numericalId || "" : "",
      url,
    })
    window.open(url, "_blank")
  }

  return (
    <div className="flex cursor-pointer flex-row items-center" onClick={onClick}>
      {getIcon(type)}
      {label && (
        <div className="ml-2">
          <Text>{label}</Text>
        </div>
      )}
    </div>
  )
}
